import { describeRuleKey, FIELD_ISSUE_RULE_KEYS } from "encamp-shared/src/waste/fieldIssueRuleKeys";
import { FilterKey } from "hooks/useOmnisearchDatagrid";

/**
 * "Data Quality Rule" filter, shared by every staff-facing manifest grid: the
 * Manifest Review queue and the staff view of a tenant's Manifests list.
 * Options come from the shared field-issue rule registry, so a new rule needs
 * no UI change here. Key is "ruleKey", which matches no grid column field on
 * either grid.
 *
 * `FIELD_ISSUE` discrepancies are staff-only (see `manifestPresenceFilters.ts`),
 * so this filter is staff-only too — every caller gates it behind the same
 * staff check as the rest of its grid's discrepancy controls.
 */
export const RULE_KEY_FILTER: FilterKey = {
  key: "ruleKey",
  header: "Data Quality Rule",
  filterKeyType: "enumAutocomplete",
  enumValues: [...FIELD_ISSUE_RULE_KEYS],
  enumPresentationFunction: describeRuleKey,
};
